import { useNavigate } from "react-router-dom";
import PaymentIcon from "@mui/icons-material/Payment";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";

function ReminderModel({ closeModel }: { closeModel: () => void; }) {
  const navigate = useNavigate();

  return (
    <div className="fixed inset-0 z-[200] flex items-center justify-center bg-black/50 backdrop-blur-sm">
      <div className="relative w-full max-w-md mx-4 rounded-xl shadow-xl overflow-hidden bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700">
        {/* Header */}
        <div className="px-6 py-4" style={{ background: 'linear-gradient(90deg, #174d7a 0%, #1d5c91 100%)' }}>
          <h2 className="text-xl font-semibold text-white flex items-center gap-2">
            <NotificationsActiveIcon sx={{ fontSize: 24 }} />
            Payment Reminder
          </h2>
        </div>

        {/* Content */}
        <div className="px-6 py-5 space-y-4">
          <p className="font-medium text-slate-800 dark:text-slate-200">Dear User,</p>
          <p className="leading-relaxed text-slate-600 dark:text-slate-400">
            We hope you're enjoying our software! To continue using all the
            features and benefits, please kindly proceed with your payment at
            your earliest convenience.
          </p>
          <p className="text-slate-600 dark:text-slate-400">Thank you for your prompt attention to this matter.</p>
          <div className="pt-2 text-slate-700 dark:text-slate-300">
            <p>Best regards,</p>
            <p className="font-semibold" style={{
              background: 'linear-gradient(90deg, #174d7a 0%, #1d5c91 100%)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text'
            }}>
              Care32 Dent Software
            </p>
          </div>
        </div>

        {/* Footer / Buttons */}
        <div className="px-6 py-4 flex gap-3 justify-end border-t bg-slate-50 dark:bg-slate-700/50 border-slate-200 dark:border-slate-600">
          <button
            onClick={() => closeModel()}
            className="px-5 py-2.5 rounded-xl font-medium transition-colors duration-200 text-slate-700 dark:text-slate-200 bg-white dark:bg-slate-600 border border-slate-300 dark:border-slate-500 hover:bg-slate-100 dark:hover:bg-slate-500"
          >
            OK
          </button>
          <button
            onClick={() => navigate("/client/pay")}
            className="flex items-center gap-2 px-5 py-2.5 text-white rounded-xl font-medium hover:shadow-lg transition-all duration-200 shadow-md focus:outline-none"
            style={{
              background: 'linear-gradient(90deg, #174d7a 0%, #1d5c91 100%)'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = 'linear-gradient(90deg, #1a5f95 0%, #2169a3 100%)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = 'linear-gradient(90deg, #174d7a 0%, #1d5c91 100%)';
            }}
            onMouseDown={(e) => {
              e.currentTarget.style.background = 'linear-gradient(90deg, #144366 0%, #1a4d73 100%)';
            }}
            onMouseUp={(e) => {
              e.currentTarget.style.background = 'linear-gradient(90deg, #1a5f95 0%, #2169a3 100%)';
            }}
          >
            <PaymentIcon sx={{ fontSize: 18 }} />
            Pay Now
          </button>
        </div>
      </div>
    </div>
  );
}

export default ReminderModel;
